import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
// import { Button, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import { getUserInfo } from '_utils/localData'

const greeting = {
  getGreeting() {
    const hour = moment().hour()
    if (hour < 12) {
      return 'Good morning'
    }
    if (hour < 18) {
      return 'Good afternoon'
    }
    return 'Good evening'
  }
}

export default function DashboardHeader({
  filters,
  events,
  // isViewAll,
  // setIsViewAll,
  selectedGroupId
}) {
  const history = useHistory()

  const userInfo = getUserInfo()
  const userGroups = userInfo?.groups || []
  const currentGroup = userGroups.find((g) => g.gid === selectedGroupId)
  const isAdmin = currentGroup?.isAdmin === 1

  const selectedEvent = events?.find((e) => e.id === filters.eid)
  const eventTitle = selectedEvent?.title || ''

  const startToShow = filters.start
    ? moment.unix(filters.start).format('DD/MM/YYYY')
    : moment().subtract(30, 'days').format('DD/MM/YYYY')

  const endToShow = filters.end
    ? moment.unix(filters.end).format('DD/MM/YYYY')
    : moment().format('DD/MM/YYYY')

  // const handleClickViewAll = () => {
  //   const nextViewAll = !isViewAll
  //   setIsViewAll(nextViewAll)
  // }

  return (
    <div className='mb-2'>
      <div className='d-flex justify-content-between align-items-start'>
        <div className='header-dashboard'>
          <span className='header-dashboard-title'>Dashboard</span>
          <p className='header-dashboard-description'>{greeting.getGreeting()}, {userInfo?.name}. Here&apos;s your group buy summary.</p>
        </div>
        <div className='d-flex gap-1 align-items-center'>
          <button className="button-create-event" onClick={() => history.push('/event/hosting')}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 1v10M1 6h10"/></svg>
            New Event
          </button>
          <button className="button-export" >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            Export Report
          </button>
        </div>
      </div>
      <div className='d-flex justify-content-end align-items-center'>
        {isAdmin && (
          <>
            {/* <Button
              id='view-all-tooltip-target'
              className='button-mode-view-all w-auto me-2'
              color={!isViewAll ? 'white' : '#ff6b00'}
              style={{
                color: !isViewAll ? '#ff6b00' : '#ffffff',
                backgroundColor: !isViewAll ? '#ffffff' : '#ff6b00',
              }}
              onClick={() => handleClickViewAll()}
            >
              Mode: {!isViewAll ? 'View All' : 'View Admin'}
            </Button>
            {!isViewAll && (
              <UncontrolledTooltip placement='right'
              target='view-all-tooltip-target' style={{ fontSize: 12 }}>
                You can only see the revenue overview for this Group.
              </UncontrolledTooltip>
            )} */}
          </>
        )}
        {filters.eid ? (
          <div className=''>
            <span className='fw-bold' style={{ fontSize: 13 }}>
              Event: <strong className='text-orange'>{eventTitle}</strong>
            </span>
          </div>
        ) : (
          <div className=''>
            <span className='fw-bold' style={{ fontSize: 13 }}>Loading report from <strong className='text-orange'>{startToShow}</strong> to{' '}
              <strong className='text-orange'>{endToShow}</strong>
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
